import isEmpty from 'lodash/isEmpty';
import { Calendar, Clock, MapPin, Presentation } from 'lucide-react';
import React from 'react';
import { getDate } from '../../../app/utils/date';
import { messageCardUtil } from './MatchBody';
import { MatchMessageCardflagLabel } from './utils/matchMessageCardflagLabel';

interface EventMessageCardProps extends React.HTMLAttributes<HTMLDivElement> {
  content: any;
}

const EventMessageCard = ({ content }: EventMessageCardProps) => {
  const options: any = {};
  options.pills = [];
  options.subHeader;

  const location = content.location ? content.location : null;
  const startDate = content.startDate ? getDate(Number(content?.startDate), ' ', 'short') : null;
  const endDate = content.endDate ? getDate(Number(content?.endDate), ' ', 'short') : null;

  let dateDisplay = null;
  if (startDate && endDate) {
    dateDisplay = startDate == endDate ? startDate : `${startDate} - ${endDate}`;
  }
  if (startDate && !endDate) {
    dateDisplay = startDate;
  }

  let timeDisplay = null;
  if (!isEmpty(content.startTime) || !isEmpty(content.endTime)) {
    if (!isEmpty(content.startTime)) {
      timeDisplay = content.startTime;
    }
    if (!isEmpty(content.startTime) && !isEmpty(content.endTime)) {
      timeDisplay = `${timeDisplay} - ${content.endTime}`;
    }
    if (isEmpty(content.startTime) && !isEmpty(content.endTime)) {
      timeDisplay = `${content.endTime}`;
    }
  }

  const info = MatchMessageCardflagLabel(content.eventType, <Presentation />);

  if (content.eventType) {
    options.subHeader = info;
  }

  if (dateDisplay) {
    options.pills.push({
      icon: <Calendar />,
      text: dateDisplay
    });
  }

  if (timeDisplay) {
    options.pills.push({
      icon: <Clock />,
      text: timeDisplay
    });
  }

  if (location) {
    options.pills.push({
      icon: <MapPin />,
      text: location
    });
  }

  options.entityColor = 'banana';
  options.entityName = 'event';

  return messageCardUtil({ content, options });
};

export default EventMessageCard;
